import React, { useCallback, useState } from 'react';

import Alert, { AlertVariant } from '../../../components/Alert';

import Checkbox from '../../../components/Checkbox';

import bf2022 from '../../../assets/svg/bf-2022.svg';
import happyKids from '../../../assets/svg/bf-2022-happy-kids.svg';

import HtmlInput from '../../../interfaces/HtmlInput';
import validations from '../../../helpers/Validations';

import Input from '../../../components/Input';

import ServiceRegistration from '../../../services/RegisterService';

interface Usuario {
  nome: string;
  email: string;
  celular: string;
  optin: boolean;
}

export function BlackFriday() {
  const [user, setUser] = useState<Usuario>({
    email: '',
    nome: '',
    celular: '',
  } as Usuario);
  const [checked, setChecked] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [validCellNumber, setValidCellNumber] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [variant, setVariant] = useState<AlertVariant>('success');
  const [message, setMessage] = useState(<></>);

  const serviceRegistration = new ServiceRegistration();
  const onlyNumber = (number: string) => number.replace(/[^0-9]/g, '');

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (!validCellNumber || !validEmail) {
      setVariant('warning');
      setShowMessage(true);
      return setMessage(<>Por favor, insira os dados corretamento.</>);
    }
    if (
      user.email &&
      user.email !== '' &&
      user.nome &&
      user.nome !== '' &&
      user.celular &&
      user.celular !== ''
    ) {
      try {
        await preRegister();
      } catch {
        setVariant('warning');
        setShowMessage(true);
        setMessage(<>Não foi possível efetuar o cadastro, tente mais tarde.</>);
      }
      return;
    }
    setVariant('warning');
    setShowMessage(true);
    setMessage(<>Preencha os campos do formulário</>);
  };

  const preRegister = async () => {
    const body = {
      celular: user.celular,
      email: user.email,
      nome: user.nome,
      optinWhats: user.optin ?? checked,
    };
    await serviceRegistration.registerInBlackFriday(body).then(() => {
      setVariant('success');
      setShowMessage(true);
      setMessage(<>Cadastro realizado com sucesso!</>);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    });
  };

  const handleClickCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
  };

  const handleChange = useCallback(
    (e: any) => {
      if (e.target && typeof e.target.value !== undefined) {
        setUser({
          ...user,
          [e.target.name]: e.target.value,
        });
      }
    },
    [user]
  );

  const validCellPhone = (e: any) => {
    if (e?.target?.value) {
      setUser({
        ...user,
        celular: onlyNumber(e.target.value),
      });
    }
    setValidCellNumber(e.isValid);
  };

  const setEmailValue = (e: any) => {
    if (e.target && typeof e.target.value !== undefined) {
      setUser({
        ...user,
        [e.target.name]: e.target.value,
      });
    }
    setValidEmail(e.isValid);
  };

  return (
    <>
      <div className="bg-[#0002db]">
        <div className="max-w-[90rem] pt-[4.25rem] pr-[12.313rem] pl-5 grid [grid-template:'logo_user-form'_'logo-happyKids_user-form'_/_1fr_0.7fr] gap-x-12 max-md:grid-cols-1 max-md:[grid-template-areas:'logo''user-form''logo-happyKids'] max-md:px-6 max-md:pt-[0.875rem] max-md:gap-0">
          <img src={bf2022} alt="" className="[grid-area:logo]" />
          <div className="[grid-area:user-form] max-md:mb-[4.188rem] [&_h1]:text-[#fae209] [&_h1]:font-bold [&_h1]:text-[2.75rem] [&_h1]:leading-[3.3rem] [&_h1]:mb-6 [&_p]:text-white [&_p]:font-medium [&_p]:text-base [&_p]:leading-6 [&_p]:mb-8 [&_label]:text-white [&_label]:text-base [&_label]:mt-0 [&_label]:mb-2">
            <h1>No momento, pausamos os novos cadastros.</h1>
            <p>
              Do dia 04/11 até 28/11, estaremos focados em realizar a maior Black Friday do Brasil.
              <br />
              Até lá, preencha seus dados abaixo e assim que voltarmos, entraremos em contato com
              você.
            </p>
            <form noValidate onSubmit={handleSubmit} className="w-full mp-bf__form">
              <Input
                id={'mp-bf__input-register_email'}
                label="E-mail"
                type="email"
                name="email"
                rules={[(val: HtmlInput) => validations.isValidEmail(val, true)]}
                onChange={(e: any) => setEmailValue(e)}
              />
              <Input
                id={'mp-bf__input-register_name'}
                label="Nome e sobrenome"
                type="text"
                name="nome"
                rules={[(val: HtmlInput) => validations.required(val, 'nome e sobrenome')]}
                onChange={handleChange}
              />
              <Input
                id={'mp-bf__input-register_cell'}
                label="Telefone celular"
                type="phone"
                name="celular"
                maskType="cellphone"
                rules={[
                  (val: HtmlInput) => validations.length(val, 15, 'celular'),
                  (val: HtmlInput) => validations.required(val, 'celular'),
                  (val: HtmlInput) => validations.isNotPhoneNumber(val, 'celular'),
                ]}
                onChange={(e: any) => validCellPhone(e)}
              />
              <div className="flex items-center gap-2">
                <Checkbox
                  label="Aceito receber informações via Whatsapp"
                  value={checked}
                  onChange={handleClickCheckBox}
                />
              </div>
              <button
                id="mp-bf__btn-submit_register"
                type="submit"
                className="flex items-center justify-center w-full bg-[#fae209] rounded-lg font-semibold text-base leading-5 py-[0.875rem]"
              >
                Enviar dados
              </button>
            </form>
          </div>
          <img src={happyKids} alt="" className="[grid-area:logo-happyKids]" />
        </div>
      </div>
      <div className="absolute top-[3.688rem] right-[5.5rem] w-[23.625rem]">
        <Alert
          show={showMessage}
          variant={variant}
          onClose={() => {
            setShowMessage(false);
          }}
          dismissible
        >
          <p>{message}</p>
        </Alert>
      </div>
    </>
  );
}
